import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, computed, signal } from '@angular/core';
import { NHAPopupComponent } from '@nha/components/popup';
import { MatChipsModule } from '@angular/material/chips';
import { NHAChipComponent } from '@nha/components/chip';
import { NHAFilterChipContentComponent } from '../filter-chip-content/filter-chip-content.component';
import { FilterBaseSlideComponent } from '../../classes/filter-base-slide-component.class';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
	standalone: true,
	selector: 'nha-filter-chip',
	imports: [
		CommonModule,
		NHAPopupComponent,
		MatChipsModule,
		MatButtonModule,
		MatIconModule,
		MatTooltipModule,
		NHAChipComponent,
		NHAFilterChipContentComponent
	],
	templateUrl: './filter-chip.component.html',
	styleUrls: ['./filter-chip.component.scss']
})
export class NHAFilterChipComponent extends FilterBaseSlideComponent {
	popupOpen = signal<boolean>(false);
	isSelected = computed(() => this.filter().items.some((i) => i.selected));

	filterTitle = computed(() => {
		const selectedItems = this.filter().items.filter((i) => i.selected);

		if (selectedItems.length === 1) {
			return this.filter().title + ': ' + selectedItems[0].label;
		}

		if (selectedItems.length > 1) {
			return this.filter().title + `: ${selectedItems.length} selected`;
		}

		return this.filter().title;
	});

	constructor(protected readonly _cdr: ChangeDetectorRef) {
		super(_cdr);
	}

	deselectAllFilterItems(): void {
		const filterKey = this.filterKey();
		const filterMap = this.filterState.getFilterMap(this.key())();
		if (!filterMap) {
			return;
		}

		const filter = filterMap[filterKey];
		if (!filter) {
			return;
		}

		const updatedFilter = {
			...filter,
			items: filter.items.map((item) => ({ ...item, selected: false }))
		};

		this.filterState.updateFilter(this.key(), filterKey, updatedFilter);
		this.popupOpen.set(false);
	}
}
